import { Reducer } from 'redux';

import { NetworkTopThreadsLoadAction } from '../../domains/networkTopThreads/actions.types';

import { NetworkTopThreadsLifecycle } from './types';

const initialState: NetworkTopThreadsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<NetworkTopThreadsLifecycle, NetworkTopThreadsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NETWORK_TOP_THREADS.LOAD_PENDING':
      return { ...initialState, pending: true };
    case 'NETWORK_TOP_THREADS.LOAD_FULFILLED':
      return { ...initialState, fulfilled: action.payload.entities.networkTopThreads };
    case 'NETWORK_TOP_THREADS.LOAD_REJECTED':
      return { ...initialState, rejected: action.payload.error };
    default:
      return state;
  }
};

export default reducer;
